module.exports = __webpack_public_path__ + "img/img4.bbac5732.png";